import React, { useCallback, useEffect } from 'react'
import { Breadcrumbs, InsideFooter, Stepper } from '../../../../components'
import { DefaultUserPage } from '../../../DefaultPages'
import { Container, Top } from '../../styles'
import { signUpActions } from '../../../../redux/ducks/signUp'
import { useSelector } from 'react-redux'
import useActions from '../../../../hooks/useActions'
import StepOne from '../../../SignUp/Step1'
import StepThree from '../../../SignUp/Step3'
import StepFour from '../../../SignUp/Step4'
import FinishStep from '../../../SignUp/FinishStep'
import { Typography } from '../../../../components/Typography/styles'
import { StepContainer } from './styles'
import LocalStorageService from '../../../../services/LocalStorageService'
import {
  getAddressStreet,
  getAddressNumber,
  getAddressComplement
} from './helpers'
import { signUpStepIcons } from '../../../../constants/signUp'

const NewBrand = () => {
  const user = LocalStorageService.get('user') || {}
  const { resetState, setStep1 } = useActions(signUpActions)
  const { actualStep, step1 } = useSelector((state) => state.signUp)

  const updateState = useCallback(() => {
    const [company] = user.companies || []
    resetState()
    if (company?.cnpj) {
      setStep1({
        ...step1,
        cnpj: company?.cnpj,
        razaoSocial: company?.corporateName,
        address: getAddressStreet(company?.address),
        number: getAddressNumber(company?.address),
        complement: getAddressComplement(company?.address),
        zipCode: company?.zipCode,
        city: company?.city,
        state: company?.state,
        country: company?.country
      })
    }
  }, [resetState, setStep1, step1, user.companies])

  useEffect(() => {
    if (step1.cnpj === '') {
      updateState()
    }
  }, [actualStep, step1.cnpj, updateState])

  useEffect(() => {
    return () => {
      resetState()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <DefaultUserPage page="brands">
      <Container>
        <Top>
          <Breadcrumbs />
        </Top>
        <Typography type="h3" color="#151515">
          Cadastro de nova loja e aquisição de certificado
        </Typography>
        <StepContainer>
          <Stepper
            stepIcons={signUpStepIcons.filter((_, i) => i !== 1)}
            filling={actualStep}
          />
          {actualStep === 1 && step1.cnpj && <StepOne isNewBrand />}
          {actualStep === 2 && <StepThree />}
          {actualStep === 3 && <StepFour />}
          {actualStep === 4 && <FinishStep />}
          <InsideFooter />
        </StepContainer>
      </Container>
    </DefaultUserPage>
  )
}

export default NewBrand
